<template>
	<div>
		<div class="kpi-grid mt-10">
			<div class="card-base card-shadow--small kpi-card sales-stats-card mb-20" :class="{ 'kpi-card--double': isCurrentUserRep == true && isCurrentUserAdmin === true }">
				<div class="widget-header kpi-card-header">
					<div class="flex justify-center align-center kpi-main-row" v-loading="loading">
						<div class="widget-icon-box mr-10 " >
							<i v-bind:class="getIconBadgeBoxClass" ></i>
							<div class="badge-box" v-if="showPercentage">
								<span  class="badge"><i v-bind:class="getTrendBadgeBoxClass" ></i><strong v-bind:class="getTextColorClass">{{focusTotalAgencyPercentage}}%</strong></span>
							</div>
						</div>
						<div class="widget-info box grow text-truncate">
							<div class="o-050 widget-title text-truncate pt-5 pb-10">
								<span v-if="isCurrentUserRep == true && isCurrentUserAdmin != true">{{$t('dashboards.globalValuesTitle')}} </span>
								<span v-if="isCurrentUserRep == true && isCurrentUserAdmin == true">{{$t('dashboards.globalValuesTitle')}} </span>
								<span v-if="isCurrentUserRep == false && isCurrentUserAdmin == true">{{$t('dashboards.globalValuesTitleEnterprise')}} </span>
								<el-popover
									placement="top-start"
									title="Information"
									width="200"
									trigger="hover">
									<p style="word-break: normal;">{{ $t('dashboards.infoGlobaValues') }}</p>
									<span slot="reference" class="mdi mdi-help-circle-outline"></span>
								</el-popover>
							</div>
							<h2 class="m-0 text-truncate">{{formatAmount(focusThisYearTotalSales)}}</h2>
						</div>
					</div>
					<el-divider v-if="isCurrentUserRep == true && isCurrentUserAdmin === true"></el-divider>
					<div class="flex justify-center align-center kpi-secondary-row" v-loading="loading" v-if="isCurrentUserRep == true && isCurrentUserAdmin === true">
						<div class="widget-icon-box mr-10">
							<i v-bind:class="getSecondIconBadgeBoxClass"></i>
							<div class="badge-box" v-if="showPercentage">
								<span  class="badge"><i v-bind:class="getSecondTrendBadgeBoxClass" ></i><strong v-bind:class="getSecondTextColorClass" >{{secondFocusTotalAgencyPercentage}}%</strong></span>
							</div>
						</div>
						<div class="widget-info box grow text-truncate">
							<div class="o-050 widget-title text-truncate pt-5 pb-10">
								<span>{{$t('dashboards.globalValuesTitleEnterprise')}} </span>
								<el-popover
									placement="top-start"
									title="Information"
									width="200"
									trigger="hover"">
									<p style="word-break: normal;">{{ $t('dashboards.infoEnterpriseGlobaValues') }}</p>
									<span slot="reference" class="mdi mdi-help-circle-outline"></span>
								</el-popover>
							</div>
							<h2 class="m-0 text-truncate">{{formatAmount(secondFocusThisYearTotalSales)}}</h2>
						</div>
					</div>
				</div>
			</div>
			<div class="card-base card-shadow--small kpi-card sales-stats-card mb-20" :class="{ 'kpi-card--double': isCurrentUserRep == true && isCurrentUserAdmin === true }">
				<div class="widget-header kpi-card-header">
					<div class="flex justify-center align-center kpi-main-row" v-loading="loading">
						<div class="widget-icon-box mr-10">
							<i v-bind:class="getAgencyFeeIconBadgeBoxClass"></i>
							<div class="badge-box" v-if="showPercentage">
								<span  class="badge"><i v-bind:class="getAgencyFeeTrendBadgeBoxClass"></i><strong v-bind:class="getAgencyFeeTextColorClass">{{focusTotalAgencyFeesPercentage}}%</strong></span>
							</div>
						</div>
						<div class="widget-info box grow text-truncate">
							<div class="o-050 widget-title text-truncate pt-5 pb-10">
								<span  v-if="isCurrentUserRep == true && isCurrentUserAdmin !== true">{{$t('dashboards.globalSalesTitle')}} </span>
								<span v-if="isCurrentUserRep == true && isCurrentUserAdmin == true">{{$t('dashboards.globalSalesTitle')}} </span>
								<span v-if="isCurrentUserRep == false && isCurrentUserAdmin == true">{{$t('dashboards.globalSalesTitleEnterprise')}} </span>
								<el-popover
									placement="top-start"
									title="Information"
									width="200"
									trigger="hover">
									<p style="word-break: normal;">{{ $t('dashboards.infoGlobaSales') }}</p>
									<span slot="reference" class="mdi mdi-help-circle-outline"></span>
								</el-popover>
							</div>
							<h2 class="m-0 text-truncate">{{formatAmount(focusThisYearAgencyFees)}}</h2>
						</div>
					</div>
					<el-divider v-if="isCurrentUserRep == true && isCurrentUserAdmin === true"></el-divider>
					<div class="flex justify-center align-center kpi-secondary-row" v-loading="loading" v-if="isCurrentUserRep == true && isCurrentUserAdmin === true">
						<div class="widget-icon-box mr-10">
							<i v-bind:class="getSecondAgencyFeeIconBadgeBoxClass"></i>
							<div class="badge-box" v-if="showPercentage">
								<span  class="badge"><i v-bind:class="getSecondAgencyFeeTrendBadgeBoxClass"></i><strong v-bind:class="getSecondAgencyFeeTextColorClass">{{secondFocusTotalAgencyFeesPercentage}}%</strong></span>
							</div>
						</div>
						<div class="widget-info box grow text-truncate">
							<div class="o-050 widget-title text-truncate pt-5 pb-10">
								<span>{{$t('dashboards.globalSalesTitleEnterprise')}} </span>
								<el-popover
									placement="top-start"
									title="Information"
									width="200"
									trigger="hover"">
									<p style="word-break: normal;">{{ $t('dashboards.infoEnterpriseGlobaSales') }}</p>
									<span slot="reference" class="mdi mdi-help-circle-outline"></span>
								</el-popover>
							</div>
							<h2 class="m-0 text-truncate">{{formatAmount(secondFocusThisYearAgencyFees)}}</h2>
						</div>
					</div>
				</div>
			</div>
			<div class="card-base card-shadow--small kpi-card sales-stats-card mb-20" :class="{ 'kpi-card--double': isCurrentUserRep == true && isCurrentUserAdmin === true }">
				<div class="widget-header kpi-card-header">
					<div class="flex justify-center align-center kpi-main-row" v-loading="loading">
						<div class="widget-icon-box mr-10">
							<i v-bind:class="getQtyCsIconBadgeBoxClass"></i>
							<div class="badge-box" v-if="showPercentage">
								<span  class="badge"><i v-bind:class="getQtyCsTrendBadgeBoxClass"></i><strong v-bind:class="getQtyCsTextColorClass">{{focusTotalQtyCsPercentage}}%</strong></span>
							</div>
						</div>
						<div class="widget-info box grow text-truncate">
							<div class="o-050 widget-title text-truncate pt-5 pb-10">
								<span v-if="isCurrentUserRep == true && isCurrentUserAdmin !== true">{{$t('dashboards.globalQty9L')}}</span>
								<span v-if="isCurrentUserRep == true && isCurrentUserAdmin == true">{{$t('dashboards.globalQty9L')}} </span>
								<span v-if="isCurrentUserRep == false && isCurrentUserAdmin == true">{{$t('dashboards.globalQty9LEnterprise')}} </span>
							</div>
							<h2 class="m-0 text-truncate">{{formatNumber(focusThisYearQtyCs)}}</h2>
						</div>
					</div>
					<el-divider v-if="isCurrentUserRep == true && isCurrentUserAdmin === true"></el-divider>
					<div class="flex justify-center align-center kpi-secondary-row" v-loading="loading" v-if="isCurrentUserRep == true && isCurrentUserAdmin === true">
						<div class="widget-icon-box mr-10">
							<i v-bind:class="getSecondQtyCsIconBadgeBoxClass"></i>
							<div class="badge-box" v-if="showPercentage">
								<span  class="badge"><i v-bind:class="getSecondQtyCsTrendBadgeBoxClass"></i><strong v-bind:class="getSecondQtyCsTextColorClass">{{secondFocusTotalQtyCsPercentage}}%</strong></span>
							</div>
						</div>
						<div class="widget-info box grow text-truncate">
							<div class="o-050 widget-title text-truncate pt-5 pb-10">{{$t('dashboards.globalQty9LEnterprise')}}</div>
							<h2 class="m-0 text-truncate">{{formatNumber(secondFocusThisYearQtyCs)}}</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs'
import salesAPI from '@/services/API/sales.js'
import portausUtils from '@/utils/portaus-utils';
import { mapGetters } from 'vuex';
export default {
	name: 'InfoStatsCard12MonthComparison',
	props : {
		inventoryIds: {
			type: Array
		}
	},
	data () {
		return {
			loading: true,
			totalValue: 0,
			totalAgencyFee:  0,
			totalDiscountAmount: 0,
			totalQty: 0,
			totalQty9L: 0,
			focusTrend: 'mdi-trending-up',
			focusStatus: 'accent',
			icon: 'mdi-cash',
			focusTrendAgencyFee: 'mdi-trending-up',
			focusStatusAgencyFee: 'accent',
			iconAgencyFee: 'mdi-currency-usd',
			iconCs : 'mdi mdi-numeric-9-box-outline',
			focusTotalAgencyPercentage: 0,
			focusTotalAgencyFeesPercentage: 0,
			focusLastYearTotalSales: 0,
			focusThisYearTotalSales: 0,
			focusLastYearAgencyFees: 0,
			focusThisYearAgencyFees: 0,
			focusLastYearQtyCs: 0,
			focusThisYearQtyCs: 0,
			focusTrendQtyCs: 'mdi-trending-up',
			focusStatusQtyCs: 'accent',
			iconQtyCs: 'mdi-currency-usd',
			focusTotalQtyCsPercentage: 0,
			secondFocusLastYearAgencyFees: 0,
			secondFocusThisYearAgencyFees : 0,
			secondFocusLastYearQtyCs: 0,
			secondFocusThisYearQtyCs: 0,
			secondFocusLastYearTotalSales: 0,
			secondFocusThisYearTotalSales: 0,
			secondFocusStatus: 'accent',
			secondFocusTrend: 'mdi-trending-up',
			secondFocusTotalAgencyPercentage : 0,
			secondFocusStatusQtyCs: 'accent',
			secondFocusTrendQtyCs: 'mdi-trending-up',
			secondFocusTrendAgencyFee: 'mdi-trending-up',
			secondFocusTotalQtyCsPercentage : 0,
			secondFocusStatusAgencyFee: 'accent',
			secondFocusTotalAgencyFeesPercentage: 0,
			fetchPeriod: 'year', // Permet de faire le calcul sur des mois au lieu d'année.
			comparison: true,
			nbPeriod: 1, //Permet de faire le calcul sur plusieurs période (ex: 6 mois);
			showPercentage: true,
		}
	},
	computed : {
		getIconBadgeBoxClass(){
			return "widget-icon mdi "+ this.icon + " " + this.getTextColorClass+ " fs-30";
		},
		getSecondIconBadgeBoxClass(){
			return "widget-icon mdi "+ this.icon + " " + this.getSecondTextColorClass+ " fs-30";
		},
		getTrendBadgeBoxClass(){
			return "mdi "+this.focusTrend+ " "+this.getTextColorClass + " mr-10";
		},
		getSecondTrendBadgeBoxClass(){
			return "mdi "+this.secondFocusTrend+ " "+this.getSecondTextColorClass + " mr-10";
		},
		getTextColorClass(){
			return this.focusStatus + "-text";
		},
		getSecondTextColorClass(){
			return this.secondFocusStatus + "-text";
		},
		getAgencyFeeIconBadgeBoxClass(){
			return "widget-icon mdi "+ this.iconAgencyFee + " " + this.getAgencyFeeTextColorClass+ " fs-30";
		},
		getSecondAgencyFeeIconBadgeBoxClass(){
			return "widget-icon mdi "+ this.iconAgencyFee + " " + this.getSecondAgencyFeeTextColorClass+ " fs-30";
		},
		getAgencyFeeTrendBadgeBoxClass(){
			return "mdi "+this.focusTrendAgencyFee+ " "+this.getAgencyFeeTextColorClass + " mr-10";
		},
		getSecondAgencyFeeTrendBadgeBoxClass(){
			return "mdi "+this.secondFocusTrendAgencyFee+ " "+this.getSecondAgencyFeeTextColorClass + " mr-10";
		},
		getAgencyFeeTextColorClass(){
			return this.focusStatusAgencyFee + "-text";
		},
		getSecondAgencyFeeTextColorClass(){
			return this.secondFocusStatusAgencyFee + "-text";
		},
		getQtyCsIconBadgeBoxClass(){
			return "widget-icon mdi "+ this.iconCs + " " + this.getQtyCsTextColorClass+ " fs-30";
		},
		getSecondQtyCsIconBadgeBoxClass(){
			return "widget-icon mdi "+ this.iconCs + " " + this.getSecondQtyCsTextColorClass+ " fs-30";
		},
		getQtyCsTrendBadgeBoxClass(){
			return "mdi "+this.focusTrendQtyCs+ " "+this.getQtyCsTextColorClass + " mr-10";
		},
		getSecondQtyCsTrendBadgeBoxClass(){
			return "mdi "+this.secondFocusTrendQtyCs+ " "+this.getSecondQtyCsTextColorClass + " mr-10";
		},
		getQtyCsTextColorClass(){
			return this.focusStatusQtyCs + "-text";
		},
		getSecondQtyCsTextColorClass(){
			return this.secondFocusStatusQtyCs + "-text";
		},
		prepareBuildRequest () {
			var utc = require('dayjs/plugin/utc')
			dayjs.extend(utc)
			let filters = {};
		
			filters.detailed = false;

			if (!_.isEmpty(this.inventoryIds)) {
				filters.inventoryId = _.map(this.inventoryIds, inv => (inv));
			}

			return filters;
		},
		...mapGetters(['isCurrentUserRep', 'getCurrentUserId', 'getCurrentPortausCompany', 'isCurrentUserAdmin'])
	},
	watch: {
        inventoryIds: function (val) {
            this.fetchData();
        },
        repId: function (val) {
			this.fetchData();
        }
    },
	methods : {
		showStats(stat){
			return _.isNumber(stat);
		},
		fetchData() {
			this.loading = true;
			return Promise.all([
				this.fetchFocusSales(),
				this.isCurrentUserRep === true && this.isCurrentUserAdmin === true ? this.fetchSecondFocusSales() : null
			]).then(() => {
				this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			})
			
			
		},
		fetchSecondFocusSales () {
			// return Promise.resolve([]);
			return this.fetchSales(null, this.nbPeriod, this.fetchPeriod)
			.then(([thisYear, lastYear]) => {
				const thisYearSales = _.head(thisYear);
				const lastYearSales = _.head(lastYear);

				this.secondFocusLastYearAgencyFees = Number(lastYearSales.agencyfees) - Number(lastYearSales.discount);
				this.secondFocusThisYearAgencyFees = Number(thisYearSales.agencyfees) - Number(thisYearSales.discount);

				this.secondFocusLastYearQtyCs = Number(lastYearSales.qty9l);
				this.secondFocusThisYearQtyCs = Number(thisYearSales.qty9l);

				this.secondFocusLastYearTotalSales = Number(lastYearSales.value) + Number(lastYearSales.agencyfees) - Number(lastYearSales.discount);
				this.secondFocusThisYearTotalSales = Number(thisYearSales.value) + Number(thisYearSales.agencyfees) - Number(thisYearSales.discount);

				const division = (this.secondFocusThisYearTotalSales - this.secondFocusLastYearTotalSales)  / this.secondFocusLastYearTotalSales;
				
				if (division < 0) {
					this.secondFocusStatus = 'danger';
					this.secondFocusTrend = 'mdi-trending-down';
					this.secondFocusTotalAgencyPercentage = ((division * 100) * -1).toFixed(2);
				} else if (division > 0.005 ){
					this.secondFocusTrend = 'mdi-trending-up';
					this.secondFocusTotalAgencyPercentage = ((division * 100)).toFixed(2);
				} else {
					this.secondFocusTrend = 'mdi-trending-neutral';
					this.secondFocusTotalAgencyPercentage = ((division * 100)).toFixed(2);
				}

				const divisionAgencyFees = (this.secondFocusThisYearAgencyFees - this.secondFocusLastYearAgencyFees) / this.secondFocusLastYearAgencyFees;
			
				if (divisionAgencyFees < 0) {
					this.secondFocusStatusAgencyFee = 'danger';
					this.secondFocusTrendAgencyFee = 'mdi-trending-down';
					this.secondFocusTotalAgencyFeesPercentage = ((divisionAgencyFees * 100) * -1).toFixed(2);
				} else if (divisionAgencyFees > 0.005 ){
					this.secondFocusTrendAgencyFee = 'mdi-trending-up';
					this.secondFocusTotalAgencyFeesPercentage = ((divisionAgencyFees * 100)).toFixed(2);
				} else {
					this.secondFocusStatusAgencyFee = 'accent';
					this.secondFocusTrendAgencyFee = 'mdi-trending-neutral';
					this.secondFocusTotalAgencyFeesPercentage = ((divisionAgencyFees * 100)).toFixed(2);
				}

				const divisionQty9L = (this.secondFocusThisYearQtyCs - this.secondFocusLastYearQtyCs) / this.secondFocusLastYearQtyCs;
				if (divisionQty9L < 0) {
					this.secondFocusStatusQtyCs = 'danger';
					this.secondFocusTrendQtyCs = 'mdi-trending-down';
					this.secondFocusTotalQtyCsPercentage = ((divisionQty9L * 100) * -1).toFixed(2);
				} else if (divisionQty9L > 0.005 ){
					this.secondFocusStatusQtyCs = 'mdi-trending-up';
					this.secondFocusTotalQtyCsPercentage = ((divisionQty9L * 100)).toFixed(2);
				} else {
					this.secondFocusStatusQtyCs = 'accent';
					this.secondFocusTrendQtyCs = 'mdi-trending-neutral';
					this.secondFocusTotalQtyCsPercentage = ((divisionQty9L * 100)).toFixed(2);
				}
			});
		},
		fetchFocusSales () {
			return this.fetchSales(this.isCurrentUserRep === true ? this.getCurrentUserId : null, this.nbPeriod, this.fetchPeriod)
			.then(([thisYear, lastYear]) => {
				if (thisYear != null && lastYear != null) {
					const thisYearSales = _.head(thisYear);
					const lastYearSales = _.head(lastYear);

					this.focusLastYearAgencyFees = Number(lastYearSales.agencyfees) - Number(lastYearSales.discount);
					this.focusThisYearAgencyFees = Number(thisYearSales.agencyfees) - Number(thisYearSales.discount);

					this.focusLastYearQtyCs = Number(lastYearSales.qty9l) ;
					this.focusThisYearQtyCs = Number(thisYearSales.qty9l);;


					this.focusLastYearTotalSales = Number(lastYearSales.value) + Number(lastYearSales.agencyfees) - Number(lastYearSales.discount);
					this.focusThisYearTotalSales = Number(thisYearSales.value) + Number(thisYearSales.agencyfees) - Number(thisYearSales.discount);
					
					const division = (this.focusThisYearTotalSales - this.focusLastYearTotalSales) / this.focusLastYearTotalSales;
					
					if (division < 0) {
						this.focusStatus = 'danger';
						this.focusTrend = 'mdi-trending-down';
						this.focusTotalAgencyPercentage = ((division * 100) * -1).toFixed(2);
					} else if (division > 0.005 ){
						this.focusTrend = 'mdi-trending-up';
						this.focusTotalAgencyPercentage = ((division * 100)).toFixed(2);
					} else {
						this.focusTrend = 'mdi-trending-neutral';
						this.focusTotalAgencyPercentage = ((division * 100)).toFixed(2);
					}

					// const divisionAgencyFees = this.focusThisYearAgencyFees / this.focusLastYearAgencyFees;
					const divisionAgencyFees = (this.focusThisYearAgencyFees - this.focusLastYearAgencyFees) / this.focusLastYearAgencyFees;
					
					if (divisionAgencyFees < 0) {
						this.focusStatusAgencyFee = 'danger';
						this.focusTrendAgencyFee = 'mdi-trending-down';
						this.focusTotalAgencyFeesPercentage = ((divisionAgencyFees * 100) * -1).toFixed(2);
					} else if (divisionAgencyFees > 0.005 ){
						this.focusTrendAgencyFee = 'mdi-trending-up';
						this.focusTotalAgencyFeesPercentage = ((divisionAgencyFees * 100)).toFixed(2);
					} else {
						this.focusStatusAgencyFee = 'accent';
						this.focusTrendAgencyFee = 'mdi-trending-neutral';
						this.focusTotalAgencyFeesPercentage = ((divisionAgencyFees * 100) ).toFixed(2);
					}

					const divisionQty9L = (this.focusThisYearQtyCs - this.focusLastYearQtyCs) / this.focusLastYearQtyCs;
					if (divisionQty9L < 0) {
						this.focusStatusQtyCs = 'danger';
						this.focusTrendQtyCs = 'mdi-trending-down';
						this.focusTotalQtyCsPercentage = ((divisionQty9L * 100) * 1-1).toFixed(2);
					} else if (divisionQty9L > 0.005 ){
						this.focusStatusQtyCs = 'mdi-trending-up';
						this.focusTotalQtyCsPercentage = ((divisionQty9L * 100)).toFixed(2);
					} else {
						this.focusStatusQtyCs = 'accent';
						this.focusTrendQtyCs = 'mdi-trending-neutral';
						this.focusTotalQtyCsPercentage = ((divisionQty9L * 100)).toFixed(2);
					}
				}
					
				})
		},
		formatAmount(amount) {
          return portausUtils.formatAmount(amount, this.$i18n.locale);
		},
		formatNumber(amount) {
			return portausUtils.formatNumber(amount, this.$i18n.locale);
		},
		fetchSales (repId, nbPeriod = 1, fetchPeriod = 12) {
			let filtersThisYear = _.clone(this.prepareBuildRequest)
			let filtersLastYear = _.clone(this.prepareBuildRequest);
			
			filtersThisYear.startDate = dayjs().subtract(nbPeriod, fetchPeriod).utc().format();
			filtersThisYear.endDate = dayjs().add(1, 'day').utc().format();
			
			filtersLastYear.startDate = dayjs().subtract(nbPeriod * 2, fetchPeriod).utc().format();
			filtersLastYear.endDate = dayjs().subtract(nbPeriod, fetchPeriod).utc().format();

			if (repId != null) {
				filtersThisYear.repId = repId;
				filtersLastYear.repId = repId;
			}

			if (!_.isEmpty(this.inventoryIds)) {
				return Promise.all([
					salesAPI.getSalesEvolution(filtersThisYear),
					salesAPI.getSalesEvolution(filtersLastYear),
				])
			} else return Promise.resolve([null, null]);
		},
	},
	created () {
		const now = dayjs();
		const startDate = dayjs(this.getCurrentPortausCompany.portaus_start_date);
		const diffDate = now.diff(startDate, 'month')
		this.comparison = false;
		if (diffDate < 24 ) {
			this.showPercentage = false;
		}
		// if (diffDate >=24 ) {
		// 	this.fetchPeriod = 'year';
		// 	this.comparison = true;
		// 	this.nbPeriod = 1;
		// } else if (diffDate > 1) {
		// 	this.fetchPeriod = 'month';
		// 	this.comparison = true;
		// 	if (diffDate < 4) {
		// 		this.nbPeriod = 1;
		// 	} else if (diffDate < 6) {
		// 		this.nbPeriod = 2;
		// 	} else if (diffDate < 8) {
		// 		this.nbPeriod = 3;
		// 	} else if (diffDate < 10) {
		// 		this.nbPeriod = 4;
		// 	} else if (diffDate < 12) {
		// 		this.nbPeriod = 5;
		// 	} else if (diffDate < 24) {
		// 		this.nbPeriod = 6;
		// 	}
		// }
		this.fetchData();
	},

}
</script>


<style lang="scss" scoped>

.kpi-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(220px, 1fr));
	gap: 10px;
	align-items: stretch;
}

.sales-stats-card {
	padding: 16px 20px;
	min-width: 260px;
	margin-bottom: 0;

	&.kpi-card--double {
		min-height: 188px;
	}

	.kpi-card-header {
		padding: 0;
	}

	.kpi-main-row {
		margin-bottom: 6px;
		align-items: flex-start;
		column-gap: 12px;
	}

	.kpi-secondary-row {
		margin-top: 10px;
		font-size: 12px;
		align-items: flex-start;
		column-gap: 12px;
	}

	.el-divider {
		margin: 6px 0;
		background: #ebeef5;
	}

	.widget-header {
		.widget-icon-box {
			background: transparent;
			border: 0;
			border-radius: 0;
			text-align: center;
			width: 96px;
			min-width: 96px;
			padding: 0;
			flex: 0 0 96px;
		}

		.widget-icon {
			font-size: 20px !important;
			color: #909399;
		}

		.widget-title {
			font-weight: 600;
			font-size: 12px;
			line-height: 1.2;
			color: #909399;
			padding-top: 0 !important;
			padding-bottom: 4px !important;
		}
	}

	.widget-info {
		min-width: 0;
	}

	h2 {
		font-size: 22px;
		font-weight: bold;
		line-height: 1.1;
		color: #303133;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.badge-box {
		.badge {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			white-space: nowrap;
			font-size: 12px;
			line-height: 1;
		}
	}
}

@media screen and (max-width: 1440px) {
	.kpi-grid {
		grid-template-columns: repeat(2, minmax(220px, 1fr));
	}
}

@media screen and (max-width: 900px) {
	.kpi-grid {
		grid-template-columns: minmax(0, 1fr);
	}
}
</style>
